const dropShadowButton = {
    borderRadius: "5px",
    boxShadow: "3px 3px 0px 0px rgba(67,224,169,0.75)",
    textTransform: "none",
}

export {
    dropShadowButton
}
  